import { theme } from '@/consts'
import { LoginModalProvider } from '@/hooks/use-login-modal'
import BrowserLayout from '@/layouts/browser-layout'
import EscapeAntd from '@c/escape-antd'
import loading from '@i/global/loading.svg'
import { setBaseAttachUrl } from '@jhqn/utils'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { queryClient } from '@u/query-client'
import { App as AntdApp, ConfigProvider, Spin } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import { Provider } from 'jotai'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import App from './App'
import '@unocss/reset/tailwind-compat.css'
import '@/assets/styles/var.scss'
import '@/assets/styles/font.scss'
import './index.scss'
import 'virtual:uno.css'

setBaseAttachUrl(import.meta.env.VITE_BASE_ATTACH_URL)

Spin.setDefaultIndicator(<img alt="loading" src={loading} style={{ fontSize: '80px' }} />)

const root = createRoot(document.getElementById('root')!)

const Application = () => {
  return (
    <StrictMode>
      <BrowserRouter basename={import.meta.env.VITE_APP_BASE}>
        <BrowserLayout>
          <ConfigProvider locale={zhCN} theme={theme}>
            <QueryClientProvider client={queryClient}>
              <AntdApp message={{ maxCount: 3 }}>
                <Provider>
                  <LoginModalProvider>
                    <App />
                  </LoginModalProvider>
                </Provider>
                <EscapeAntd />
                <ReactQueryDevtools initialIsOpen={false} />
              </AntdApp>
            </QueryClientProvider>
          </ConfigProvider>
        </BrowserLayout>
      </BrowserRouter>
    </StrictMode>
  )
}

const deferRender = async () => {
  if (__PROD__) return

  const { worker } = await import('./mocks/browser')

  return worker.start({
    onUnhandledRequest: 'bypass',
    quiet: true,
    serviceWorker: {
      url: `${import.meta.env.BASE_URL}mockServiceWorker.js`,
      options: {
        scope: import.meta.env.BASE_URL,
      },
    },
  })
}

deferRender().then(() => {
  root.render(<Application />)
})
